
import axios from 'axios';

import { EncApi } from '../Comunes/Listas';


const Gestion43 = async (xmlDocRef, NombreArchivo, RespuestaAceptacion, Actividad, TipoDocElec, Token, IdCia) => {
    try {
        
        let xmlDoc;
        const parser = new DOMParser();
        const decodedString = atob(xmlDocRef);
        xmlDoc = parser.parseFromString(decodedString, "text/xml");

        const I = {
            DocNum: 0,
            Detalle: [],
        };

        

        const root = xmlDoc.documentElement;

        I.ConsecutivoProveedor = root.querySelector("NumeroConsecutivo")?.textContent || "N/A";
        I.ClaveProveedor = root.querySelector("Clave")?.textContent || "N/A";
        I.Actividad = Actividad;
        I.IdCia = IdCia;
        try {
            I.CorreoProveedor = root.querySelector("Emisor > CorreoElectronico")?.textContent || "";
        } catch {
            I.CorreoProveedor = "";
        }

        try {
            const receptorId =
                root.querySelector("Receptor > Identificacion > Numero")?.textContent || "N/A";
            I.Sucursal = receptorId !== "701500604" ? "001" : "001";
        } catch {
            return {
                NombreArchivo,
                resultado: `Factura ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} No trae cedula en el RECEPTOR.`,
            };
        }

        try {
            I.Terminal = 1;
            I.TipoDoc = TipoDocElec;
            I.Nota = `Aceptación ${TipoDocElec}  ${I.ConsecutivoProveedor}`;
            I.EstadoAceptacion = RespuestaAceptacion;
            I.FechaFactura = new Date(root.querySelector("FechaEmision")?.textContent).toISOString() || new Date().toISOString();
            I.CedulaCL = root.querySelector("Receptor > Identificacion > Numero")?.textContent || "N/A";
            I.CedulaPR = root.querySelector("Emisor > Identificacion > Numero")?.textContent || "N/A";
            I.TipoPR = root.querySelector("Emisor > Identificacion > Tipo")?.textContent || "N/A";
            I.NombrePR = root.querySelector("Emisor > Nombre")?.textContent || "N/A";

            I.Moneda =
                root.querySelector("ResumenFactura > CodigoTipoMoneda > CodigoMoneda"
                )?.textContent || "CRC";

            I.TC =
                parseFloat(
                    root.querySelector("ResumenFactura > CodigoTipoMoneda > TipoCambio"
                    )?.textContent
                ) || 0;

            const resumenFacturaFields = [
                "TotalServGravados",
                "TotalServExentos",
                "TotalServExonerado",
                "TotalMercanciasGravadas",
                "TotalMercanciasExentas",
                "TotalMercExonerada",
                "TotalDescuentos",
                "TotalImpuesto",
                "TotalIVADevuelto",
                "TotalOtrosCargos",
            ];

            resumenFacturaFields.forEach((field) => {
                I[field] =
                    parseFloat(root.querySelector("ResumenFactura > " + field)?.textContent || 0);
            });


            const XmlNodeList = root.querySelector("DetalleServicio")?.childNodes || [];

            XmlNodeList.forEach((node) => {
                const Ln = {
                    Monto: 0,
                    ImpuestoNeto: 0,
                    CodigoImp: "01",
                    CodigoTarifa: "EX",
                    Clave: I.ClaveProveedor,
                };

                node.childNodes.forEach((child) => {
                    switch (child.nodeName) {
                        case "NumeroLinea":
                            Ln.NumeroLinea = parseInt(child.textContent.trim());
                            break;
                        case "Cantidad":
                            Ln.Cantidad = parseFloat(child.textContent.trim());
                            break;
                        case "UnidadMedida":
                            Ln.UnidadMedida = child.textContent.trim();
                            break;
                        case "Detalle":
                            Ln.Detalle = child.textContent.trim();
                            break;
                        case "PrecioUnitario":
                            Ln.PrecioUnitario = parseFloat(child.textContent.trim());
                            break;
                        case "SubTotal":
                            Ln.SubTotal = parseFloat(child.textContent.trim());
                            break;
                        case "ImpuestoNeto":
                            Ln.ImpuestoNeto = parseFloat(child.textContent.trim());
                            break;
                        case "MontoTotalLinea":
                            Ln.MontoTotalLinea = parseFloat(child.textContent.trim());
                            break;
                        case "Impuesto":
                            child.childNodes.forEach((impuestoChild) => {
                                switch (impuestoChild.nodeName) {
                                    case "Codigo":
                                        Ln.CodigoImp = impuestoChild.textContent.trim();
                                        break;
                                    case "CodigoTarifa":
                                        Ln.CodigoTarifa = impuestoChild.textContent.trim();
                                        break;
                                    case "Monto":
                                        Ln.Monto = parseFloat(impuestoChild.textContent.trim());
                                        break;
                                    case "ImpuestoNeto":
                                        Ln.ImpuestoNeto = parseFloat(
                                            impuestoChild.textContent.trim()
                                        );
                                        break;
                                    default:
                                        break;
                                }
                            });
                            break;
                        default:
                            break;
                    }
                });

                I.Detalle.push(Ln);
            });

            I.Archivo = NombreArchivo;
        } catch (exl) {
            return {
                NombreArchivo,
                resultado: `Alerta mensaje:  ${exl.message}`,
            };
        }

        const Parametro = JSON.stringify(I);
        //console.log(Parametro);

        let Rpta = {};
        const url = `https://SmartFeCr.com:2020/SmartContrackBack/api/DocumentosElectronicos/Recepcion`;
        //console.log(Parametro);
        //console.log(url);
        
        try {
            const response = await axios.post(url,Parametro, EncApi(Token));
            //console.log(response.data);
            Rpta = response.data;
        } catch (error) {
            return {
                NombreArchivo,
                resultado: "Error al comunicarse con el servicio SOAP. " + error.message,
            };
        }


        // Removed unused variable 'Resultados'
        let ObjResp= JSON.parse(Rpta);
        console.log(Rpta);
        switch (ObjResp.CodRespuesta) {
            case "0":
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} cargada exitosamente. Consecutivo: ${ObjResp.Consecutivo} Clave: ${ObjResp.Clave}`,
                };
            case "1":
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} cargada exitosamente, pero sin enviarse a Hacienda, a la espera de que se indique la actividad o tipo de aceptación `,
                };
            case "2":
                return {
                    NombreArchivo,
                    resultado: `${ObjResp.Informacion} Consecutivo: ${ObjResp.Consecutivo} Clave: ${ObjResp.Clave}`,
                };
            case "-1":
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} No se creo, favor valide el contenido ${ObjResp.Informacion}.`,
                };
            case "-2":
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} ${ObjResp.Informacion}.`,
                };
            case "-3":
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} ${ObjResp.Informacion}.`,
                };
            default:
                return {
                    NombreArchivo,
                    resultado: `Documento ${I.ConsecutivoProveedor} Proveedor ${I.NombrePR} ${ObjResp.Informacion}.`,
                };
        }
    } catch (ex) {
        return {
            NombreArchivo,
            resultado: `Alerta en Gestion43: ${ex.message}`,
        };
    }
};
/*
const enviarSolicitudSOAP = async (contenido) => {
    const NombreArchivo = "ArchivoEjemplo.xml"; // Ajusta según sea necesario

    // Construcción del cuerpo en XML
    const xmlBody = `<?xml version="1.0" encoding="utf-8"?>
        <soap12:Envelope xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance"
                         xmlns:xsd="http://www.w3.org/2001/XMLSchema"
                         xmlns:soap12="http://www.w3.org/2003/05/soap-envelope">
            <soap12:Body>
                <Recepcion xmlns="http://tempuri.org/">
                    <Contenido>${contenido}</Contenido> 
                </Recepcion>
            </soap12:Body>
        </soap12:Envelope>`;

    const url = "http://smartfecr.com:2007/DocumentoElectronico.asmx";
    console.log("Contenido XML:", xmlBody);
    let Rpta = "";
    try {
        const response = await axios.post(url, xmlBody, {
            headers: { 
                "Content-Type": "application/soap+xml; charset=utf-8"
            },
        });
        Rpta = response.data;
    } catch (error) {
        return {
            NombreArchivo,
            resultado: "Error al comunicarse con el servicio SOAP. " + error.message,
        };
    }
    console.log("Respuesta del servicio SOAP:", Rpta);
    return {
        NombreArchivo,
        resultado: Rpta,
    };
};
*/
export default Gestion43;